import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button } from "@material-ui/core";
import PaperContainer from '../../Common/PaperContainer';
import UploadFileOrTemplate from './../../Common/UploadFileOrTemplate';
import t from "../../../languages/pl";
import ClientsTable from './ClientsTable';
import ClientDialog from './ClientDialog';
import SearchField from '../../Common/InputFields/SearchField';
import { compose } from "recompose";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import ActionCreator from './../../../store/actions/index';
import ClientTemplate from '../../../templates/ClientTemplate.csv';
import {notArrayOrEmpty } from '../../../utils/helpers';


const useStyles = theme => ({
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    search: {
        marginRight: "auto",
        marginLeft: theme.spacing(1)
    }
});

const checkIfAnyPropertyMatch = (obj, criteria) => {
    let values = Object.values(obj);
    values = values.filter(value => typeof value === 'string' && value.toLowerCase().includes(criteria.toLowerCase()));
    return values.length > 0;
};

const Clients = props => {
    const { classes, clients, addRentClient, putRentClient, deleteRentClient, importClients } = props;
    const [open, setOpen] = useState(false);
    const [client, setClient] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [sortedClients, setSortedClients] = useState(clients);
    const [searchClient, setSearchClient] = useState('');

    useEffect(() => {
        let sorted = clients;
        if(typeof searchClient === 'string' && searchClient.length > 0)
            sorted = sorted.filter(client => checkIfAnyPropertyMatch(client, searchClient));
        setSortedClients(sorted);
    }, [searchClient, clients]);

    const handleClientManageClick = id => {
        setClient(sortedClients.find(element => element.klient_id === id));
        setClientId(id);
        setOpen(true);
    };

    const handleClientSubmit = (data, initialClient) => {
        delete data.klient_rodzaj_lista;
        delete data.klient_id;
        setOpen(false);
        setClient(initialClient);
        addRentClient(data);
    };

    const handleClientEdit = (data, initialClient) => {
        delete data.klient_rodzaj_lista;
        setOpen(false);
        setClient(initialClient);
        putRentClient(data.klient_id,data);
    };

    const onCloseHandler = (initialClient) => {
        setOpen(false);
        setClient(initialClient);
        setClientId(null);
    };

    const onDeleteConfirmHandler = (id, initialClient) => {
        setClient(initialClient);
        setClientId(null);
        setOpen(false);
        deleteRentClient(id);
    };

    const handleCsvLoaded = (data) => {
        if (notArrayOrEmpty(data))
            return false;
        let newData = data.map(record => {
            let newRecord = mapClientsFromCsv(record);
            return {
                ...newRecord,
            };
        });
        if(!notArrayOrEmpty(newData))
            importClients(newData);
    };

    const mapClientsFromCsv = (record) => (
        {
            kierowca: {
                imie: record["Kierowca imię"],
                kod: record["Kierowca kod pocztowy"],
                miasto: record["Kierowca miejscowość"],
                pesel: record["Kierowca PESEL"],
                telefon: record["Kierowca telefon"],
                ulica: record["Kierowca ulica"],
                prawo: record["Kierowca prawo jazdy"],
                data_prawa: record["Kierowca data wydania prawa jazdy"],
                organ: record["Kierowca organ wydający prawo jazdy"]
            },
            klient_dowod: record["Dowód osobisty"],
            klient_email: record.Email,
            klient_kod: record["Kod pocztowy"],
            klient_limitkm: record["Limit km"],
            klient_miasto: record.Miejscowość,
            klient_nazwa: record.Nazwa,
            klient_nip: record.NIP,
            klient_pesel: record.PESEL,
            klient_regon: record.REGON,
            klient_rodzaj: record.Typ,
            klient_telefon: record.Telefon,
            klient_ulica: record.Ulica,
            klient_uwagi: record.Uwagi
        }
    );

    return (
        <PaperContainer>
            <div className={classes.buttons}>
                <SearchField
                    className={classes.search}
                    options={clients.map(client => client.nazwa)}
                    onChange={(value) => setSearchClient(value)}
                />
                <UploadFileOrTemplate
                    template={ClientTemplate}
                    onFileLoaded={handleCsvLoaded}
                    tooltipText={t.importClientsFromFile}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(true)}
                >
                    {t.addClient}
                </Button>
            </div>
            <ClientsTable
                clients={sortedClients}
                onClientsManageClick={handleClientManageClick}
            />
            <ClientDialog
                open={open}
                onClose={onCloseHandler}
                client={client}
                onSubmit={handleClientSubmit}
                onEdit={handleClientEdit}
                onDeleteConfirm={onDeleteConfirmHandler}
                isEdit={clientId !== null}
            />
        </PaperContainer>
    );
};

Clients.propTypes = {
    classes: PropTypes.object,
    clients: PropTypes.array,
    addRentClient: PropTypes.func,
    putRentClient: PropTypes.func,
    deleteRentClient: PropTypes.func,
    importClients: PropTypes.func
};

const mapStateToProps = state => ({
    clients: state.rentReducer.clients,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

    export default compose(
        withStyles(useStyles),
        connect(
            mapStateToProps,
            mapDispatchToProps
        )
    )(Clients);
